var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgForbidden(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8ZM11.4766 12.8907C10.4958 13.5892 9.29586 14 8 14C4.68629 14 2 11.3137 2 8C2 6.70414 2.41081 5.50423 3.1093 4.52339L11.4766 12.8907ZM12.8908 11.4765L4.52354 3.1092C5.50434 2.41077 6.7042 2 8 2C11.3137 2 14 4.68629 14 8C14 9.2958 13.5892 10.4957 12.8908 11.4765Z",
    fill: "currentColor"
  })));
}

export default SvgForbidden;